import React, { useState, useMemo, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "../CSS/RingkasanAnalitikTK.css";

const API_BASE = "https://api-tibismart.tifpsdku.com/api";


function RingkasanAnalitikTK() {
  const [selectedFilter, setSelectedFilter] = useState("Tahun");
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [summary, setSummary] = useState({
    total_screening: 0,
    suspected: 0,
    normal: 0,
    tenaga_kesehatan: 0,
    dokter_paru: 0,
  });

  // =========================
  // FETCH DATA ANALITIK
  // =========================
  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const [screeningRes, summaryRes] = await Promise.all([
          fetch(`${API_BASE}/analytics/screening?tahun=${selectedFilter}`),
          fetch(`${API_BASE}/analytics/summary`),
        ]);

        const screeningData = await screeningRes.json();
        const summaryData = await summaryRes.json();

        setFullData(screeningData || []);
        setSummary(summaryData || {});
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [selectedFilter]);

  // =========================
  // FILTER DATA
  // =========================


  // =========================
  // HITUNG STATISTIK
  // =========================
  const statistik = {
    total: summary.total_screening,
    suspected: summary.suspected,
    normal: summary.normal,
    tenaga: summary.tenaga_kesehatan,
    dokter: summary.dokter_paru,
  };

  if (loading) {
    return <p style={{ padding: 20 }}>Memuat data analitik...</p>;
  }

  return (
    <div className="ringkasan-page">
      <div className="main-content-ringkasan">
        <div className="ringkasan-container">

          {/* ================= TOP CARD ================= */}
          <div className="top-card-container">
            <div className="top-card yellow glow">
              <p className="label">Total Screening</p>
              <h1 className="angka">{statistik.total}</h1>
              <p className="keterangan">Berbasis CNN</p>
            </div>

            <div className="top-card blue glow">
              <p className="label">Tenaga Medis Aktif</p>
              <h1 className="angka">{statistik.tenaga}</h1>
              <p className="keterangan">Terdaftar di sistem</p>
            </div>

            <div className="top-card green glow">
              <p className="label">Dokter Paru</p>
              <h1 className="angka">{statistik.dokter}</h1>
              <p className="keterangan">Terdaftar di sistem</p>
            </div>
          </div>

          {/* ================= GRAFIK ================= */}
          <div className="chart-container">
            <div className="chart-header">
              <p className="chart-title">Analitik Screening TBC</p>

              <select
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
                className="dropdown-filter"
              > 
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2024">2023</option>
                <option value="2024">2022</option>
              </select>
            </div>

            <ResponsiveContainer width="100%" height={350}>
              <LineChart data={fullData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="bulan" />
                <YAxis />
                <Tooltip />
                <Legend />

                <Line
                  dataKey="total"
                  name="Total Screening"
                  stroke="#2563EB"
                  strokeWidth={3}
                />
                <Line
                  dataKey="suspected"
                  name="Suspected TB"
                  stroke="#F59E0B"
                  strokeWidth={2}
                />
                <Line
                  dataKey="normal"
                  name="Normal"
                  stroke="#16A34A"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* ================= SIDEBAR ================= */}
      <div className="sidebar-kanan-ringkasan">
        <div className="right-card total">
          <p>Total Screening</p>
          <h1>{statistik.total}</h1>
        </div>
        <div className="right-card putus">
          <p>Suspected TB</p>
          <h1>{statistik.suspected}</h1>
        </div>
        <div className="right-card selesai">
          <p>Normal</p>
          <h1>{statistik.normal}</h1>
        </div>
      </div>
    </div>
  );
}

export default RingkasanAnalitikTK;
